import React from 'react';

const QuotePage = () => {
  return (
    <div data-testid="quote-page" style={{ width: '100%', height: '100vh', margin: 0, padding: 0 }}>
      <iframe
        src="/quote/index.html"
        title="Get Your Online Quote — Romano Heating & Cooling"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
        }}
      />
    </div>
  );
};

export default QuotePage;
